import { endpoints } from '@/api/endpoints';
import type { LocationLabelsInput, LocationLabelsResult } from '@/api/types';

/** Ask the server for the PDF and hand it to the browser as a download (same mechanism as invoices). */
export async function downloadLocationLabels(warehouseId: string, input: LocationLabelsInput): Promise<LocationLabelsResult> {
  const r = await endpoints.locationLabels(warehouseId, input);
  const a = document.createElement('a');
  a.href = `data:application/pdf;base64,${r.bytesBase64}`;
  a.download = r.filename;
  a.click();
  return r;
}
